import React, { useState, useEffect } from 'react';
import { CheckCircleIcon } from '@heroicons/react/outline';

const Licenses = ({ user, setUser, database, getDate, getYear, getTime }) => {
  const charlingtonEpoch = 1766275200000;

  const [licenses, setLicenses] = useState([]);

  useEffect(setValues, []);

  function setValues() {
    database
      .ref('/licenses')
      .get()
      .then((licensesSnapshot) => {
        if (licensesSnapshot.val() != undefined) {
          setLicenses(Object.values(licensesSnapshot.val()));
        }
      });
    database
      .ref(`/citizens/${user.citizenID}`)
      .get()
      .then((userSnapshot) => {
        console.log('user retrieved', userSnapshot.val());
        if (userSnapshot.val() != undefined) {
          setUser(userSnapshot.val());
        }
      });
  }

  function onClickBuyLicense(license) {
    const addedLicense = JSON.parse(JSON.stringify(license));
    addedLicense.datePurchased = `${getDate()}, ${getYear()}`;
    if (Number(user.westers) >= Number(license.price)) {
      database
        .ref(`/citizens/${user.citizenID}/licenses/${license.licenseID}`)
        .set(addedLicense);
      database
        .ref(`/licenses/${license.licenseID}/owners/${user.citizenID}`)
        .set({
          citizenID: user.citizenID,
          datePurchased: `${getDate()}, ${getYear()}`,
        });
      const userResultingBalance = Number(
        (Number(user.westers) - Number(license.price)).toFixed(2)
      );
      const transferID = generateID5Digits('MT');
      database
        .ref(`/government/westers`)
        .get()
        .then((westersSnapshot) => {
          const governmentWesters = Number(westersSnapshot.val());
          const governmentResultingBalance =
            Number(governmentWesters) + Number(license.price);
          database.ref('/government/westers').set(governmentResultingBalance);
          database
            .ref(`/citizens/${user.citizenID}/westers`)
            .set(Number(userResultingBalance));
          database
            .ref(`/citizens/${user.citizenID}/transfers/${transferID}`)
            .set({
              transferID: transferID,
              date: `${getDate()}, ${getYear()}`,
              time: getTime(),
              mssce: Math.round(new Date().getTime() - charlingtonEpoch),
              amount: Number(license.price),
              receiverName: 'Charlington Establishment and Zard',
              type: 'Outgoing',
              reason: `Purchased ${license.title} ${license.licenseID}`,
              resultingBalance: userResultingBalance,
            });
          database.ref(`/government/transfers/${transferID}`).set({
            transferID: transferID,
            date: `${getDate()}, ${getYear()}`,
            time: getTime(),
            mssce: Math.round(new Date().getTime() - charlingtonEpoch),
            amount: Number(license.price),
            senderName: user.name,
            senderCitizenID: user.citizenID,
            type: 'Incoming',
            reason: `Purchased ${license.title} ${license.licenseID}`,
            resultingBalance: governmentResultingBalance,
          });
          setValues();
        });
    }
  }

  function generateID(prefix) {
    var id = `${prefix}-`;
    for (var i = 0; i < 4; i++) {
      id = id + String(Math.floor(Math.random() * 10));
    }
    return id;
  }

  function generateID5Digits(prefix) {
    var id = `${prefix}-`;
    for (var i = 0; i < 5; i++) {
      id = id + String(Math.floor(Math.random() * 10));
    }
    return id;
  }

  function userOwnsLicense(license) {
    userOwnsLicense = false;
    if (user.licenses != undefined) {
      Object.values(user.licenses).forEach((userLicense) => {
        if (userLicense.licenseID == license.licenseID) {
          userOwnsLicense = true;
        }
      });
      return userOwnsLicense;
    } else {
      return false;
    }
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <div className='mx-1 lg:mx-10 my-1 lg:my-5'>
      <div className='py-2 w-full flow-root'>
        <p className='float-left text-4xl font-bold'>Licenses</p>
        <div className='float-right'>
          <p className='font-bold text-center'>Personal Balance</p>
          <p className='text-center border border-gray-400 shadow font-semibold bg-gray-600'>
            W{user.westers}
          </p>
        </div>
      </div>
      <div className='px-2 py-1 lg:px-6 lg:py-3 rounded bg-gray-700'>
        {licenses.map((license) => {
          return (
            <div className='lg:py-3 py-1'>
              <License license={license} />
            </div>
          );
        })}
      </div>
    </div>
  );

  function License({ license }) {
    return (
      <div className='border border-gray-400 bg-gray-800 shadow p-2'>
        <div className='flow-root'>
          <div className='float-left'>
            <p className='text-lg font-semibold'>{license.title}</p>
            <p className='font-semibold text-gray-400'>{license.licenseID}</p>
          </div>
          <p className='float-right font-bold text-xl'>W{license.price}</p>
        </div>
        <div className='lg:flow-root'>
          <p className='pt-2 pr-2 font-semibold lg:float-left'>
            {license.permissions}
          </p>
          {user.licenses != undefined &&
          Object.keys(user.licenses).includes(license.licenseID) ? (
            <div className='flex lg:float-right'>
              <CheckCircleIcon className='w-7 h-7 text-white' />
              <p className='lg:float-right font-bold px-1 text-lg'>
                Purchased {user.licenses[license.licenseID].datePurchased}
              </p>
            </div>
          ) : (
            <button
              className={classNames(
                Number(user.westers) < Number(license.price)
                  ? 'bg-sky-300 text-gray-400'
                  : 'bg-sky-400 hover:bg-sky-500',
                'font-semibold shadow rounded p-2 lg:float-right w-full mt-2 lg:mt-0 lg:w-52 text-lg'
              )}
              onClick={() => {
                onClickBuyLicense(license);
              }}
            >
              {user.westers < license.price ? "CAN'T AFFORD THIS" : 'BUY'}
            </button>
          )}
        </div>
      </div>
    );
  }
};

export default Licenses;
